import { App } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { TASK_STATUS } from '@/constants/task';
import { ApiError } from '@/services/api/client';
import * as tasksApi from '@/services/api/tasks';

export interface EmployeeTaskStats {
  total: number;
  pendingComplete: number;
  overdue: number;
}

const EMPTY_STATS: EmployeeTaskStats = {
  total: 0,
  pendingComplete: 0,
  overdue: 0,
};

export function useEmployeeTaskStats() {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState<EmployeeTaskStats>(EMPTY_STATS);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [allResult, overdueResult, pendingResult, inProgressResult] = await Promise.all([
        tasksApi.fetchTasks({ page: 1, pageSize: 1 }),
        tasksApi.fetchTasks({ page: 1, pageSize: 1, overdueOnly: true }),
        tasksApi.fetchTasks({ page: 1, pageSize: 1, status: TASK_STATUS.PENDING }),
        tasksApi.fetchTasks({ page: 1, pageSize: 1, status: TASK_STATUS.IN_PROGRESS }),
      ]);

      setStats({
        total: allResult.total,
        pendingComplete: pendingResult.total + inProgressResult.total,
        overdue: overdueResult.total,
      });
    } catch (error) {
      const text = error instanceof ApiError ? error.message : '加载任务统计失败';
      message.error(text);
      setStats(EMPTY_STATS);
    } finally {
      setLoading(false);
    }
  }, [message]);

  useEffect(() => {
    void load();
  }, [load]);

  return { loading, stats, reload: load };
}
